import * as actionTypes from "../actions/actionTypes";

const initialState = {
  data: null,
};

export default (state = initialState, action = {}) => {

  switch (action.type) {
    case actionTypes.PEER_SAVE:
      return {
        ...state,
        data: action.data,
      };


      
    default:
      return state;
  }
};
